import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import jump from 'jump.js';
// import RecaptchaPlugin from '../plugins/recaptcha';

export default {

  props: {

      supplies: {
          type: Object,
          required: true
      }

  },

  data() {

      return {

          recaptchaStateLoaded: false,
          formProgress: false,
          sent: false,
          formErrorJump: false

          // captchaAction: 'showPhone',
          // verified: undefined

      }

  },

  watch: {

      formProgress(n, o) {

        if(n == true) {

          this.showBadge();

        } else {

          this.hideBadge();

        }
        
      }

  },

  mounted() {

    if(!this.recaptchaStateLoaded) {

      this.loadRecaptcha();

    }
    
  },

  methods: {

      // async loadRecaptcha() {

      //     if (!this.$recaptcha) {
      //         await RecaptchaPlugin.install(Vue, {
      //             key: this.supplies.sitekey,
      //             action: this.captchaAction,
      //         });
      //     } else {
      //         await this.$recaptcha.refreshToken();
      //     }
      // },

      // verify() {

      //     return this.$http.post('/v1/api/verify-token', {
      //         recaptchaToken: this.$recaptcha.token
      //     }).catch((err) => {
      //         console.log('Verify token err', err);
      //     });
      // },

      loadRecaptcha() {

        this.recaptchaStateLoaded = true;

        VueReCaptcha(Vue, {
          siteKey: this.supplies.sitekey,
          // loaderOptions: {
          //   autoHideBadge: true
          // }
        });

        // this.$nextTick(() => {
        
        //   this.hideBadge();

        // });

      },

      formValidate() {

        if(this.formProgress) {

          return;
        }

        this.formProgress = true;

        this.$refs.form.validate().then(success => {

          if(!success) {

            var errEl = false;

            // jump to an error message
            $('.js-ferror').each((i, e) => {

              if(!errEl) {

                if($(e).html() !== '') {

                  errEl = e;

                }

              }

            });

            if(errEl && !this.formErrorJump) {

              this.formErrorJump = true;

              setTimeout(() => {

                this.formErrorJump = false;

              }, 1000);



              jump(errEl, {

                duration: 500,
                offset: -($('.g.g--header').height() > 100 ? $('.g.g--header').height() : 0) - 70

              });

            }

            this.formProgress = false;

            return;
          }

          this.recaptcha();

        });

      },

      async recaptcha() {

        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded()

        // Execute reCAPTCHA with action "login".
        const token = await this.$recaptcha(this.recaptchaName).then((token) => {
          
          this.formProceed(token);

        }, error => {

          this.formProceed = false;

        });

      },

      // async recaptcha() {

      //     await this.loadRecaptcha();
      //     return new Promise((resolve) => {
      //         if (typeof this.verified === 'undefined') {
      //             this.verify().then((resp) => {
      //                 this.verified = +data.result.score > 0.7;
      //                 // here you can save this result to store 
      //                 // if you want to keep it and do not make request each time to API or emit some event
      //                 resolve(this.verified);
      //                 this.formProceed(resp);
      //             });
      //         } else {
      //             resolve(this.verified);
      //             this.formProceed = false;
      //         }
      //     });
      // },

      errorHandler(error, ref) {

        for (const [key, value] of Object.entries(error)) {

          this.$refs[ref ? ref : ('fr-' + key)].applyResult({

            errors: [ value ],
            valid: false,
            failedRules: {}

          });

        }

      },

      showBadge() {

        $('.grecaptcha-badge').addClass('grecaptcha-badge-show');

      },

      hideBadge() {

        $('.grecaptcha-badge').removeClass('grecaptcha-badge-show');

      }

  }

}